import * as env from "../config/env"
import axiosInstance from "../config/axios.config";


const headers = {
  'Accept': 'application/json',
  'Content-Type': 'application/json',
};

const baseUrl = env.url
console.log(baseUrl);
export function getOrderDetails(barcode) {
  const config = {
    method: "GET",
    headers
  }
  return axiosInstance(`${baseUrl}/api/orders/${barcode}`, config).then(responseSuccessHandler).catch(responseErrorHandler)
}

export function getLocation(referenceId) {
  const config = {
    method: "GET",
    headers
  }
  return axiosInstance(`${baseUrl}/api/racks/${referenceId}`, config).then(responseSuccessHandler).catch(responseErrorHandler)
}

export function getBins() {
  const config = {
    method: "GET",
    headers
  }
  return axiosInstance(`${baseUrl}/api/racks`, config).then(responseSuccessHandler).catch(responseErrorHandler)
}

export function getShelved(referenceId) {
  const config = {
    method: "GET",
    headers
  }
  return axiosInstance(`${baseUrl}/api/racks/shelved/${referenceId}`, config).then(responseSuccessHandler).catch(responseErrorHandler)
}

export function shelved(shelvedObj) {
  const config = {
    method: "POST",
    headers,
    data: shelvedObj
  }
  return axiosInstance(`${baseUrl}/api/racks/shelved`, config).then(responseSuccessHandler).catch(responseErrorHandler)
}

export function storeRacks(racks, location) {
  const config = {
    method: "POST",
    headers,
    data: {
      "rackMaps": JSON.stringify(racks),
      "location": location
    }
  }
  return axiosInstance(`${baseUrl}/api/racks/store`, config).then(responseSuccessHandler).catch(responseErrorHandler)
}

export function updateRacks(racks) {
  const config = {
    method: "PUT",
    headers,
    data: {
      "rackMaps": JSON.stringify(racks)
    }
  }
  return axiosInstance(`${baseUrl}/api/racks/update/1`, config).then(responseSuccessHandler).catch(responseErrorHandler)
}

export function storeLocation(locationObj) {
  const config = {
    method: "POST",
    headers,
    data: locationObj
  }
  return axiosInstance(`${baseUrl}/api/racks/storeLoc`, config).then(responseSuccessHandler).catch(responseErrorHandler)
}

export function empty(emptyObj) {
  const config = {
    method: "POST",
    headers,
    data: emptyObj
  }
  return axiosInstance(`${baseUrl}/api/racks/empty`, config).then(responseSuccessHandler).catch(responseErrorHandler)
}

export function deleteOrder(referenceId) {
  const config = {
    method: "DELETE",
    headers,
  }
  return axiosInstance(`${baseUrl}/api/racks/del/${referenceId}`, config).then(responseSuccessHandler).catch(responseErrorHandler)
}

const responseSuccessHandler = response => {
  return response.data;
}

const responseErrorHandler = error => {
  return Promise.reject(error);
}